<script lang="ts">
	import RecorderWave from './RecorderWave.svelte'
	import RecorderTimer from './RecorderTimer.svelte'
	import type { RecorderState } from '@repo/commons/models'
	import { createWebAudioAdapter } from '@repo/commons/utils'
	import type { RecorderFrame } from '@repo/commons/models'
	import { Button, ButtonSize, ButtonType } from '@repo/commons/components'

	interface Props {
		onRecordingStateChange: (newState: RecorderState) => void
	}

	let { onRecordingStateChange }: Props = $props()

	let recordingState = $state<RecorderState>('idle')
	let elapsedMs = $state(0)

	let historyCapacity = $state(0)
	let history = $state<number[]>([])

	const adapter = createWebAudioAdapter()

	adapter.onState((s) => {
		recordingState = s
	})

	adapter.onFrame((frame: RecorderFrame) => {
		elapsedMs = frame.elapsedMs

		history = [...history.slice(1), frame.level]
	})

	const resizeHistory = (capacity: number) => {
		historyCapacity = capacity

		if (history.length > capacity) {
			history = history.slice(history.length - capacity)
		} else if (history.length < capacity) {
			history = [...Array(capacity - history.length).fill(0), ...history]
		}
	}

	const reset = async () => {
		await adapter.reset()

		elapsedMs = 0
		history = Array(historyCapacity).fill(0)
	}

	const start = () => {
		adapter.start()
	}

	adapter.onChunk((chunk) => {
		console.log('chunk', chunk)
	})

	const pause = () => adapter.pause()
	const resume = () => adapter.resume()
	const stop = () => adapter.stop()

	$effect(() => {
		onRecordingStateChange(recordingState)
	})

	$effect(() => {
		return () => adapter.destroy()
	})
</script>

<div class="voice-recorder">
	<div class="w-full flex items-center gap-2">
		<!--{#if recordingState === 'paused'}-->
		<!--	<Button-->
		<!--		buttonText=""-->
		<!--		buttonType={ButtonType.TERTIARY}-->
		<!--		buttonSize={ButtonSize.SMALL}-->
		<!--		rounded-->
		<!--		icon={Icon}-->
		<!--		iconProps={{ name: 'trash', size: 'md', class: 'text-[#002C4D80]' }}-->
		<!--		onclick={reset}-->
		<!--	/>-->
		<!--{/if}-->

		{#if recordingState === 'recording' || recordingState === 'paused'}
			<RecorderTimer {elapsedMs} />
		{/if}

		{#if recordingState !== 'idle'}
			<RecorderWave {history} onCapacityChange={resizeHistory} />
		{/if}
	</div>

	{#if recordingState === 'idle'}
		<Button
			buttonText=""
			buttonType={ButtonType.TERTIARY}
			buttonSize={ButtonSize.SMALL}
			rounded
			iconProps={{ name: 'microphone', size: 'md', class: 'text-[#002C4D80]' }}
			onclick={start}
		/>
	{:else if recordingState === 'recording'}
		<div class="flex items-center gap-2">
			<Button
				buttonText=""
				buttonType={ButtonType.TERTIARY}
				buttonSize={ButtonSize.SMALL}
				rounded
				iconProps={{ name: 'trash', size: 'md', class: 'text-[#002C4D80]' }}
				onclick={reset}
			/>
			<Button
				buttonText="Transcribe"
				buttonType={ButtonType.BRAND}
				buttonSize={ButtonSize.SMALL}
				onclick={reset}
			/>
		</div>
	{/if}
</div>

<style>
	.voice-recorder {
		@apply flex
    gap-2
    items-center;
	}
</style>
